import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { ChatProvider } from "./context/ChatContext";
import Navbar from "./components/Navbar";
import ChatWidget from "./components/ChatWidget";
import AdminConversationsPage from "./pages/AdminConversationsPage";
import AdminChatViewing from "./pages/AdminChatViewing";

// Main app layout component
function AppLayout() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <div className="min-h-screen">
      {/* White background for customer pages, dark gradient for admin */}
      <div
        className={
          isAdminRoute
            ? "min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900"
            : "min-h-screen bg-white"
        }
      >
        {/* Only show navbar on admin pages */}
        {isAdminRoute && <Navbar />}

        {/* Admin Routes */}
        {isAdminRoute ? (
          // <Routes>
          //   <Route
          //     path="/admin/conversations"
          //     element={<AdminConversationsPage />}
          //   />
          //   <Route path="/admin/chat/:id" element={<AdminChatViewing />} />
          //   <Route
          //     path="/admin"
          //     element={<Navigate to="/admin/conversations" replace />}
          //   />
          // </Routes>
          <></>
        ) : (
          /* Customer Pages - Empty white page with chat widget */
          <div className="h-screen flex items-center justify-center">
            <div className="text-center px-4">
              <div className="mb-8">
                <div
                  className="w-32 h-32 mx-auto mb-6 bg-gradient-to-br from-blue-100 to-purple-100 rounded-full 
                                flex items-center justify-center"
                >
                  <svg
                    className="w-16 h-16 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1.5}
                      d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                    />
                  </svg>
                </div>
              </div>
              <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
                BSA Monitoring Solutions
              </h1>
              <p className="text-lg text-gray-600 mb-2">
                Enterprise-grade monitoring and security systems
              </p>
              <p className="text-sm text-gray-500">
                Need assistance? Click the chat icon in the bottom right →
              </p>

              <div className="mt-12 flex justify-center space-x-8 text-gray-400">
                <div className="text-center">
                  <div className="text-2xl font-bold text-gray-700">24/7</div>
                  <div className="text-xs uppercase tracking-wide">Assist</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-gray-700">500+</div>
                  <div className="text-xs uppercase tracking-wide">
                    Products
                  </div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-gray-700">99.9%</div>
                  <div className="text-xs uppercase tracking-wide">Uptime</div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Chat Widget - Only show on non-admin pages */}
      {!isAdminRoute && <ChatWidget />}
    </div>
  );
}

function App() {
  return (
    <ChatProvider>
      <Router>
        <Routes>
          <Route path="/*" element={<AppLayout />} />
        </Routes>
      </Router>
    </ChatProvider>
  );
}

export default App;
